import type { TypedMyBrandNews } from './-MyBrandNews';
import RawMyBrandNews from './MyBrandNews.vue';
export * from './-MyBrandNews';
export const MyBrandNews = RawMyBrandNews as typeof TypedMyBrandNews;
